import { DigestSendNowResult } from '../../generated'

export function nothingToSendReason(result: DigestSendNowResult): string {
  return result.notRegularEvent
    ? 'The next meeting is not a regular event, so it gets no digest.'
    : 'The club has no upcoming meeting or no subscribed recipients.'
}
